import moment from 'moment';
import modal from 'helpers/modal';
import DetailsView from './DetailsModalView';
import template from 'employer/templates/reports/leave/Main.ejs';
import tableTemplate
    from 'employer/templates/reports/leave/Table.ejs';
import Report from 'newModels/report.js';

module.exports = Backbone.View.extend({
    events: {
        'click .js-filter-clear':          'resetFilter',
        'click .js-filter-apply':          'applyFilter',
        'submit form.filters':             'filter',
        'change input, select': 'taint',
        'click .js-details': 'viewDetails',
        'change .js-datepicker-input': 'updateCustomEndDate',
        'change [name=period]':    'toggleCustomEndDate',
        'click .js-send-leave-report': 'sendLeaveReport'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            employees: null,
            leaveTypes: null,
            filters:   {
                'employee[]': null,
                'leaveType': null,
                'date': null,
            },
        });

        this.renderFilters();
    },

    renderFilters: function() {
        if (this.options.filters.date) {
            this.options.filters.customEndDateFormatted = moment(
                this.options.filters.date
            ).format('MMMM, YYYY');
        } else {
            this.options.filters.customEndDateFormatted = null;
        }

        this.$el.html(template({
            filters:     this.options.filters,
            employees:   this.options.employees,
            leaveTypes:  this.options.leaveTypes
        }));

        this.$('.js-datepicker').datepicker({
            keyboardNavigation: false,
            forceParse:         false,
            autoclose:          true,
            todayBtn:           'linked',
            format:             'MM, yyyy',
            viewMode:           'months',
            minViewMode:        'months'
        });

        this.$('.chosen-select').chosen({
            width: '175px',
        });
    },

    render: function(balance = {}) {
        this.options.balance = balance;

        const periodType = this.options.filters.period;
        const leaveTypeId = this.options.filters.leaveType;
        const customEndDate = this.options.filters.date ?
            moment(this.options.filters.date, 'YYYY/MM/DD') : moment();

        const leaveTableRows = Object.values(balance)
            .map(employeeBalance => {
                const {
                    employee, entitled, taken, defaultEntitled, cf
                } = employeeBalance;

                let leavePeriodYear;

                switch (periodType) {
                    case 'current':
                        leavePeriodYear =
                            employee.getApplicableLeavePeriod(moment());
                        break;
                    case 'previous':
                        leavePeriodYear =
                            employee.getApplicableLeavePeriod(
                                moment().subtract(1, 'year')
                            );
                        break;
                    case 'custom':
                        leavePeriodYear =
                            employee.getApplicableLeavePeriod(customEndDate);
                        break;
                    default:
                        break;
                }

                return {
                    fullName: employee.get('fullName') || '',
                    employeeId: employee.id,
                    daysEntitled: defaultEntitled[leaveTypeId]
                        .formatWithoutRounding(1),
                    daysAllowed: entitled[leaveTypeId].formatWithoutRounding(1),
                    daysTaken: taken[leaveTypeId].formatWithoutRounding(1),
                    daysCarryForward: cf[leaveTypeId].formatWithoutRounding(1),
                    daysRemaining: (entitled[leaveTypeId] - taken[leaveTypeId])
                        .formatWithoutRounding(1)
                };
            });

        this.$('.leave-table-container').html(tableTemplate({
            leaveTableRows,
            isFinished: true
        }));

        this.$('.js-loader').remove();

        modal.showAlertSuccess('Employee leave balances loaded!');

        this.$('.leave-table').footable();
    },

    taint: function() {
        this.$('form.filters').addClass('tainted');
    },

    filterIsTainted: function() {
        return this.$('form.filters').hasClass('tainted');
    },

    resetFilter: function(e) {
        e.preventDefault();

        const filters = {
            period: 'current',
            employee: [],
        };

        app.mainRouter.navigate('reports/leave?' + $.param(filters), {
            trigger: true,
        });

        app.mainRouter.execute(() => {
            //clear old events, before redirect
            this.undelegateEvents();
        });
    },

    applyFilter: function(e) {
        e.preventDefault();

        if (!this.filterIsTainted()) {
            return false;
        }

        // period is translated from presets
        // current:     this year
        // previous:    previous year
        // custom:      custom date (month)
        const period = this.$('[name=period]').val();

        const leaveType = this.$('[name=leave-type]').val() === '' ?
            '' : this.$('[name=leave-type]').val();

        const customEndDate = period === 'custom' && this.options.filters.date ?
            this.options.filters.date :
            null;

        const filters = {
            period,
            leaveType,
            employee:   this.$('[name=employee]').val(),
            date: customEndDate,
        };

        app.mainRouter.navigate('reports/leave?' + $.param(filters), {
            trigger: true,
        });

        app.mainRouter.execute(() => {
            //clear old events, before redirect
            this.undelegateEvents();
        });
    },

    viewDetails(event) {
        event.preventDefault();

        const employeeId = event.target.dataset.employeeId;
        const data = this.options.balance[employeeId];

        // prepare modal view for employee leave details
        // similar to employment details
        this.detailsView = new DetailsView(data);
        this.$el.append(this.detailsView.$el);
        this.detailsView.show();
    },

    remove: function() {
        this.undelegateEvents();
    },

    updateCustomEndDate: function() {
        const customEndDate = this.$('input[name=customEndDate]').val();
        if (customEndDate) {
            this.options.filters.date =
                moment(customEndDate, 'MMMM, YYYY')
                    .endOf('month')
                    .format('YYYY/MM/DD');
        }
    },

    toggleCustomEndDate: function(event) {
        const isHidingCustomDateSelect = $(event.target).val() !== 'custom';
        this.$('input[name=customEndDate]')
            .prop('disabled', isHidingCustomDateSelect);
    },

    sendLeaveReport: function() {
        let date = null;
        switch (this.options.filters.period) {
            case 'custom':
                date = moment(this.options.filters.date || moment())
                    .endOf('day').toDate();
                break;
            case 'previous':
                date = moment().subtract(1, 'year').endOf('day').toDate();
                break;
            case 'current':
                date = moment().endOf('day').toDate();
                break;
            default:
                break;
        }

        return Report.sendLeaveReport({
            companyId: app.company.id,
            date: date,
            isEndAtDate: this.options.filters.period === 'custom'
        }).then(() => {
            modal.showAlertSuccess(
                `Employee leave report will be sent to your email shortly.`
            );
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/reports/EmployeeLeave.js